import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { Checkbox, NumberInput, TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function OffreSectionFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
        </Row>
        <Row>
            <TextInput className="grow" label={t("Nom FR")} value={item.nomFr} onChange={set('nomFr')} required />
            <TextInput className="grow" label={t("Nom NL")} value={item.nomNl} onChange={set('nomNl')} />
            <TextInput className="grow" label={t("Nom EN")} value={item.nomEn} onChange={set('nomEn')} />
        </Row>
        <Checkbox label={t("Communs")} value={item.communs} onChange={set('communs')} />
    </>
}

export function OffreSectionsList(props) {
    const t = useTranslations()
    return <ListPage model="offreSections" title={t("Sections")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Nom FR')]: 'nomFr',
        [t('Nom NL')]: 'nomNl',
        [t('Nom EN')]: 'nomEn',
        [t('Communs')]: 'communs',
    }} {...props} />
}

export function OffreSectionDetail(props) {
    const t = useTranslations()
    return <DetailPage model="offreSections" title={t("Section")} Fields={OffreSectionFields} defaults={{
        ordre: 0
    }} {...props} />
}
